import Model from "./abstract/Model";

export const roles = {
  ROLE_TYPE_SUPERADMIN: 'SUPERADMIN',
  ROLE_TYPE_ADMIN: 'ADMIN',
  ROLE_TYPE_MANAGER: 'MANAGER',
  ROLE_TYPE_USER: 'USER',
  ROLE_TYPE_DEPOT_ADMIN: 'DEPOT_ADMIN',
  ROLE_TYPE_DEPOT_USER: 'DEPOT_USER',
  ROLE_TYPE_ALARM_CENTER_MANAGER: 'MANAGER',
  ROLE_TYPE_ALARM_CENTER_ADMIN: 'ALARM_CENTER_ADMIN',
  ROLE_TYPE_ALARM_CENTER_USER: 'ALARM_CENTER_USER',
  ROLE_SENIOR: 'SENIOR',
  ROLE_TYPE_API_USER: 'API_USER',
}

export const adminRoles = [
  roles.ROLE_TYPE_SUPERADMIN,
  roles.ROLE_TYPE_ADMIN,
  roles.ROLE_TYPE_ALARM_CENTER_ADMIN,
  roles.ROLE_TYPE_DEPOT_ADMIN,
  roles.ROLE_TYPE_MANAGER
]

export const depotRoles = [
  roles.ROLE_TYPE_DEPOT_ADMIN,
  roles.ROLE_TYPE_DEPOT_USER,
]

export const alarmCenterRoles = [
  roles.ROLE_TYPE_ALARM_CENTER_ADMIN,
  roles.ROLE_TYPE_ALARM_CENTER_USER,
]

export default class Role extends Model {
  type;

  constructor(props) {
    super();
    this.initializeAttributes(props);
  }
}
